import { useMutation, UseMutationResult } from "@tanstack/react-query";

import { API_CREATE_USER_URL } from "constants/apiUrls";

import { CreateUserRequestBody } from "../types/userRegistration";
import { APIErrorTypes, InvalidFieldDetailsError } from "../types/apiError";

import getApiClient from "lib/apiClient/getApiClient";

function useCreateUser(): UseMutationResult<
  void,
  InvalidFieldDetailsError<APIErrorTypes.FormValidationError>,
  CreateUserRequestBody
> {
  const apiClient = getApiClient();

  return useMutation({
    mutationFn: async (registerDetails) => {
      const response = await apiClient(API_CREATE_USER_URL, {
        method: "POST",
        body: JSON.stringify(registerDetails),
      });

      if (!response.ok) {
        return Promise.reject(await response.json());
      } else {
        return Promise.resolve();
      }
    },
  });
}

export default useCreateUser;
